import { UIText3 } from '@cian/ui-kit';
import { IconFunctionalWarningCircle16 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'clsx';
import * as React from 'react';

import * as styles from './Pessimization.css';
import { EPessimizationBackground, IPessimization } from '../../../../types';

interface IPessimizationProps {
  pessimization: IPessimization;
}

export const Pessimization: React.FC<React.PropsWithChildren<IPessimizationProps>> = ({
  pessimization: { background, text },
  children,
}) => {
  return (
    <div className={styles['container']}>
      {children}
      <div
        className={classNames(styles['banner'], {
          [styles['banner--red']]: background === EPessimizationBackground.Red,
        })}
      >
        <IconFunctionalWarningCircle16 display="block" color="icon-inverted-default" />
        <UIText3 as="p" color="text-inverted-default" textAlign="center">
          {text}
        </UIText3>
      </div>
    </div>
  );
};
